import { useMutation } from "@tanstack/react-query";
import { AddAdventure, DeleteAdventure, UpdateAdventure } from "../services/adventureService";

export const useCreateAdventure = () => {
    const { mutate: createAdventure } = useMutation({
        mutationFn: (adventure) => AddAdventure(adventure)
    })

    return createAdventure;
}

export const useUpdateAdventure = () => {
  const { mutate: updateAdventure } = useMutation({
    mutationFn: (adventure) => UpdateAdventure(adventure),
  });

  return updateAdventure;
};

export const useDeleteAdventure = () => {
  const { mutate: deleteAdventure } = useMutation({
    mutationFn: (destination) => DeleteAdventure(destination),
  });

  return deleteAdventure;
};